<template>
  <grid-x :col="columns" row="1fr" gap="2em">
    <div class="col-1">
      <div v-if="showUploader === 'hero'">
        <div class="input-box">
          <input type="text" v-model="item.title" placeholder="Hero Text">
        </div>
      </div>
    </div>
    <div class="col-2">
      <h3>Image Preview</h3>
      <div v-if="showUploader === 'hero'" class="hero-preview">
        <div class="widget-buttons">
          <button @click="switchHero('mobile')">Mobile</button>
          <button @click="switchHero('desktop')">Desktop</button>
        </div>
        <div  class="desktop-preview">
          <div class="hero-image desktop" ref="hero">
            <img :src="previewImage ? previewImage : item.image" class="object-fit">
            <div class="hero-text">
              <h2 class="hero-text-title" v-html="item.title"></h2>
              <span class="hero-author">
                <i>by</i>
                {{item.authorName ? item.authorName : "Boaty McBoatface"}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </grid-x>
</template>

<script>
import Vue from "vue";
import gridX from "./gridX";
import { functions } from "firebase";
export default {
  components: { gridX },
  props: ["item","previewImage"],
  data() {
    return {
      showUploader: "hero",
      showUploadBtn: false,
      columns: "1fr",
      showPreview: true
    };
  },
  methods: {
    processPreviewImage: function(event) {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          Vue.set(this.item, "image", e.target.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        Vue.set(this.item, "image", "");
      }
    },
    clearUploader: function() {
      this.$refs.fileUpload.value = "";
    },
    switchHero: function(arg) {
      if (arg === "desktop") {
        return this.$refs.hero.classList.add("desktop");
      }
      return this.$refs.hero.classList.remove("desktop");
    }
  }
};
</script>

<style scoped>
h4 {
  margin-bottom: 0.25em;
}
.upload-preview {
  height: 50px;
  width: 50px;
  position: relative;
  overflow: hidden;
}

.upload-preview img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: relative;
}

.upload-preview:hover:before {
  content: "X";
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  text-align: center;
  cursor: pointer;
}

.input-box.bacteria-image-upload {
  height: 60px;
  margin-bottom: 0;
}
.image-bg {
  max-width: 318px;
  max-height: 318px;
  padding: 1em;
  background: #6384ea;
  background: url("../../assets/Pattern_Blue.svg");
  background-size: cover;
  margin: 0 auto;
}
.image-bg img {
  border-radius: 50%;
  width: 280px;
  height: 280px;
  object-fit: cover;
}
.message {
  font-size: 0.75em;
  font-weight: 600;
  font-style: italic;
}

.hero-image {
  position: relative;
  max-width: 414px;
  width: 100%;
  margin: 0 auto;
  display: block;
  margin-bottom: 5px;
}

.hero-image img {
  width: 100%;
  height: 100%;
  max-width: 1020px;
  min-height: 300px;
  max-height: 55vh;
  height: 404px;
  border-bottom: 10px solid #ffccec;
  object-fit: cover;
}

.hero-text {
  width: 100%;
  position: absolute;
  bottom: 16px;
  text-align: center;
  padding: 25vh 0.75em 1.5%;
  color: white;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.65) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#a6000000',GradientType=0 );
}

.hero-text-title {
  font-size: 23.5px;
  line-height: 28.9175px;
  font-variant-ligatures: none;
  -webkit-font-variant-ligatures: none;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  text-shadow: rgba(0, 0, 0, 0.01) 0 0 1px;
  margin-bottom: 8.24687px;
  padding: 0;
  border-bottom: 0;
  font-family: Lora, serif;
}

.hero-author {
  font-size: 11px;
  font-family: Montserrat, serif;
  text-transform: uppercase;
}
.hero-author i {
  text-transform: none;
  margin-right: 0.25em;
}

@media screen and (min-width: 800px) {
  .desktop.hero-image {
    max-width: 1020px;
    margin-bottom: 5px;
    /* border-left: 10px solid white;
    border-right: 10px solid white;
    border-top: 10px solid white; */
  }
  .desktop.hero-image img {
    max-height: 85vh;
    height: 634px;
  }

  .desktop .hero-text {
    padding: 6em 1.75em 3.5%;
    line-height: 1.285714286;
  }

  .desktop .hero-text-title {
    font-size: 42px;
    line-height: 1.19047619;
    margin-bottom: 0.19047619em;
    -webkit-text-size-adjust: 100%;
    padding: 0 0 0.238095238em 0;
  }

  .desktop .hero-author {
    font-size: 13px;
  }
}
/* @media screen and (min-width: 1040px) {
  .desktop.hero-image {
    border-left: 0;
    border-right: 0;
  }
} */
</style>



// WEBPACK FOOTER //
// heroPreview.vue?549055e4